import { render } from "./RetentionPackage.vue?vue&type=template&id=41aa08ee&scoped=true"
import script from "./RetentionPackage.vue?vue&type=script&lang=js"
export * from "./RetentionPackage.vue?vue&type=script&lang=js"

import "./RetentionPackage.vue?vue&type=style&index=0&id=41aa08ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41aa08ee"]])

export default __exports__